// extracted by mini-css-extract-plugin
export default {"logo":"v","blinking":"w","gradientShift":"x","float":"y","move":"z","scroll":"A"};